import { combineEpics } from 'redux-observable';
import { getAccountEpic } from './get-account';
import { createAccountEpic } from './create-account';
import { createOnboardingLinkEpic } from './create-onboarding-link';
import { getAccountAfterLoginEpic } from './get-account-after-login';
import { createLoginLinkEpic } from './get-login-link';
import { createTransferEpic } from './create-transfer';
import { getOnboardingLinkAfterCreateEpic } from './get-onboarding-link-after-create';
import { createAccountAfterProfileUpdateEpic } from './create-account-after-profile-update';

const stripeConnectEpic = combineEpics(
  getAccountEpic,
  createAccountEpic,
  createOnboardingLinkEpic,
  createLoginLinkEpic,
  getAccountAfterLoginEpic,
  createTransferEpic,
  getOnboardingLinkAfterCreateEpic,
  createAccountAfterProfileUpdateEpic
);

export default stripeConnectEpic;
